<template>
  <div class="full-screen" v-bind:style="{ backgroundImage: 'url(' + `${user.data.otherInfo['bg-img']}` + ')'}">
    <div class="home-donations app-bg-gradient">
    <div class="stars-bg"></div>
    <Languages class="languages" v-bind:settings="true"></Languages>
    <Timer></Timer>
    <div class="mosque-name">{{user.data.name}}</div>
    <div class="footer">{{"All Donations are Voluntary , T &amp; C applies" | translate}} </div>
    <div class="center">{{"Please review and confirm" | translate}}</div>
    <div class="center in-sentence">{{"You are donating" | translate}} <span>&#163;{{donationAmount}}</span> {{"for" | translate}} <span>{{donationType | translate}}</span></div>
    <div class="center in-sentence-rearange">{{"you" | translate}}<span>&ensp;{{donationType | translate}}&ensp;</span> {{"for" | translate}}&ensp;<span> {{donationAmount}}&#163; &ensp;</span> {{"donating" | translate}}</div>
    <div class="change-desc">{{"Please confirm or change" | translate}} </div>

    <div class="reports-section">
      <div class="change-details-sec main-donations" @click="changeAmountScreen">
        <!-- <select v-model="donationName">
            <option v-if="option.order !== 4" :key="option.title" v-for="option in user.data.donationCategories" :value="option.title">{{option.title | translate}}</option>
            <optgroup v-if="option.order === 4" :key="option.title" v-for="option in user.data.donationCategories" :label="option.title | translate">
                <option :key="category.title" v-for="category in option.childCategories" :value="category.title">{{category.title | translate}}</option>
            </optgroup>
            <optiongroup >{{option.title}}</optiongroup>
        </select> -->
        <!-- <div style="width:100%;position:relative;margin-left:35px;" @click="changeAmountScreen">
          <inputField v-bind:amount="amount" @changedAmount="changedAmount"></inputField>
          <label for="input-amount" class="pound-symbol">&#163;</label>
        </div> -->
        <div class="glow"><img src="/static/images/glow.png"/></div>
        <donationOption class="cursor"
          v-bind:option='donationDetails'
          >
        </donationOption>
      </div>
      <div class="main-donations other-amount-section"  @click="changeAmountScreen">
        <img class="cursor" src="static/images/5pounds.png" v-if="amount===5"/>
        <img class="cursor" src="static/images/10pounds.png" v-if="amount===10"/>
        <img class="cursor" src="static/images/20pounds.png" v-if="amount===20"/>
        <img class="cursor" src="static/images/50pounds.png" v-if="amount===50"/>
        <div class="other-amount cursor" v-if="(amount !== 50 && amount !== 20 && amount !== 10 && amount !== 5)">
          &#163; {{amount}}
        </div>
      </div>
      <div class="donate-now">
        <div class="btn-bg1">
          <div class="btn-bg2">
            <button  @click="changeAmountScreen" class="cursor login">{{"Change" | translate}}</button>
          </div>
        </div>
        <div class="btn-bg1">
          <div class="btn-bg2">
            <button @click="donateNow" class="cursor login">{{"Confirm" | translate}}</button>
          </div>
        </div>
        <div class="btn-bg1">
          <div class="btn-bg2">
            <button @click="back" class="cursor login">{{"Back" | translate}}</button>
          </div>
        </div>
      </div>
    <div class="danger">{{donationRequestError | translate}}</div>
  </div>
  </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import inputField from './inputComponent.vue'
import Timer from './timer.vue'
import Languages from './Languages'
import donationOption from './donationOption.vue'

export default {
  data () {
    return {
      donationName: null,
      amount: null,
      tid: null,
      donationDetails: null
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'token',
      'donationType',
      'donationAmount',
      'PSSaleRequested',
      'paymentRequestStatus',
      'donationRequestError'
    ])
  },
  watch: {
    PSSaleRequested (newValue) {
      this.startDonationProcess(newValue)
    },
    amount (newValue) {
      this.changeDonationAmount(newValue)
    },
    donationName (newValue) {
      this.changeDonationType(newValue)
    }
  },
  methods: {
    ...mapActions([
      'changeLoadingStatus',
      'requestPayment',
      'changeDonationType',
      'changeDonationAmount',
      'resetTerminalNotificationStatus'
    ]),
    changedAmount (a) {
      this.amount = a
    },
    startDonationProcess (PSSaleRequested) {
      if (PSSaleRequested) {
        this.$router.push({path: `/${this.tid}/payment-confirm/${this.donationType}/${this.donationAmount}`})
      }
    },
    changeAmountScreen () {
      this.$router.push({path: `/${this.tid}/change-amount/${this.donationType}/${this.donationAmount}`})
    },
    back () {
      this.$router.go(-1)
    },
    donateNow () {
      if (this.donationAmount !== null && this.donationType !== null) {
        this.requestPayment({
          amount: this.donationAmount,
          socket: this.$socket,
          type: this.donationType
        }).then((response) => {
          if (this.PSSaleRequested) {
            this.startDonationProcess(this.PSSaleRequested)
          }
        }).catch(error => {
          console.log(error)
        })
      } else {
        // TODO: Handle properly.
        console.log('err')
      }
    }
  },
  components: {
    inputField,
    Timer,
    Languages,
    donationOption
  },
  created: function () {
    this.amount = +this.$route.params.donationAmount
  },
  mounted: function () {
    this.donationName = this.$route.params.donationType
    this.tid = this.$route.params.terminalId
    this.changeDonationAmount(this.amount)
    this.changeDonationType(this.donationName)
    this.resetTerminalNotificationStatus()
    this.user.data.donationCategories.map((category) => {
      if (category.title === this.donationName) {
        this.donationDetails = category
      } else if (category.childCategories) {
        category.childCategories.map((child) => {
          if (child.title === this.donationName) {
            this.donationDetails = child
          }
        })
      }
    })
    this.$nextTick(() => {
      // Check wether the user has been already logged in.
      if (!this.token) {
        this.$router.push({path: `/${this.tid}/`})
      } else {
        this.changeLoadingStatus(false)
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home-donations {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}
.mosque-name {
  font-size: 40px;
  color: #FFF;
  font-family: "Lato";
  font-weight: bold;
  text-shadow: 1px 1.732px 4px rgba( 0, 0, 0, 0.45 );
  margin-top: 61px;
  margin-bottom: 50px;
  letter-spacing: 2px;
}
.amount-details-section {
  height: calc(100vh - 250px);
  width:80%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.amount-details-section > div {
  width: 45%;
  height: 100%;
  background-color: rgba(255,255,255,0.15);
  padding: 5%;
}
.other-donation-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100px;
}
.other-donation-option .btn-bg1 {
  margin-top: 0;
  margin-right: 15px;
}
.label, .error {
  font-size: 25px;
  color: #880913;
  font-weight: 600;
  letter-spacing: 2px;
  margin-bottom: 50px;
}
.error {
  font-size: 16px;
  margin-bottom: 0;
  margin-top: 30px;
}
.glow {
  position: absolute;
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
select, input {
  border: none;
  border-bottom: 1px solid #812d03;
  background-color: transparent;
  color: #FFF;
  font-size: 24px;
  font-weight: 400;
  outline: none;
  height: 50px;
  padding: 0 10px;
  cursor: pointer;
  letter-spacing: 1px;
}
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 0 30px 0 10px
  /* margin-bottom: 30px; */
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}
input {
  text-indent: 20px;
  width: 100px;
}
select option, select optgroup {
  margin: 40px;
  background: #ffffff;
  color: #000;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
}
.pound-symbol {
  position: absolute;
  font-size: 25px;
  color: #ffffff;
  top: 13px;
  left: 10px;
}
.center {
  font-size: 26px;
  font-weight: 600;
  margin-bottom: 25px;
  color: #880913;
  letter-spacing: 2px;
}
.center span {
  font-size: 36px;
}
.change-desc {
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 2px;
  color: #FFF;
  margin-top: 20px;
  margin-bottom: 20px;
}
.change-details-sec {
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.btn-bg1 {
  margin-top: 0px;
  margin: 0;
  z-index: 2;
}
.donate-now {
  z-index: 2;
}

div[dir='rtl'] select {
  background-position: 5% 60%;
  padding: 2% 4% 2% 10%;
  margin-left: 5%;
  margin-right: initial;
  width: max-content;
}
.reports-section {
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  width: 60%;
  padding: 10px 0;
  background: transparent;
  align-items: center;
  justify-content: space-between;
  height: 240px;
  z-index: 2;
}
.reports-section div.main-donations{
  width: 50%;
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  max-width: 480px;
}
.other-amount {
  background-color: rgba(255,255,255,0.29);
  height: 75%;
  width: 75%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  color: #880913;
  font-weight: 600;
}
.donate-now {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
}
.donate-now .btn-bg1:first-child {
  margin-right: 50px;
}
.donate-now .btn-bg1:last-child {
  margin-left: 50px;
}
  div[dir='rtl'] .donate-now .btn-bg1:first-child {
    margin-right: initial;
    margin-left: 50px;
  }
  .full-screen {
    background-position: 50%;
}
@media only screen and (min-width: 2000px) {
  .reports-section {
      height: 35vh !important;
      width: 80% !important;
    }
    .reports-section div.main-donations {
      height: 66%;
      max-width: 50%;
    }
    .reports-section div.main-donations.other-amount-section {
      height: 53%;
      max-width: 50%;
    }
    .reports-section div.main-donations.other-amount-section img {
      width: initial;
      height: 90%;
    }
    .other-amount {
      font-size: 120px;
    }
  .center {
    font-size: 120px;
    line-height: 100px;
    margin-bottom: 2%;
    letter-spacing: 6px;
  }
  .center span {
    font-size: 110px;
  }
  .change-desc {
    font-size: 110px;
    line-height: 100px;
    margin-bottom: 2%;
    margin-top: 5%;
    letter-spacing: 6px;
  }

  .glow img {
    width: 100%;
    height: 150%;
  }
  select, input {
    font-size: 138px;
    height: auto;
    padding: 2%;
    height: 250px;
    border-bottom-width: 20px;
    letter-spacing: 6px;
  }
  input {
    max-width: 500px;
    width: initial;
    text-indent: 120px;
    letter-spacing: 6px;
  }
  select {
    background-position: 98% 60%;
    background-size: 70px;
    margin-right: 50px;
    width: min-content;
    padding: 2% 14% 2% 2%;
  }

  .pound-symbol {
    font-size: 138px;
    line-height: 138px;
    top: 13%;
    left: 6%;
  }
    .btn-bg1 {
      margin-top: 200px;
      z-index: 2;
      width: 620px !important;
      height: 200px !important;
      border-radius: 200px;
    }
    .btn-bg2 {
      width: 607px;
      height: 187px;
      border-radius: 200px;
    }
    button {
      width: 594px;
      height: 178px;
      border-radius: 200px;
      font-size: 70px;
      letter-spacing: 3px;
    }
  div[dir='rtl'] select {
    background-position: 5% 60%;
    padding: 2% 4% 2% 12%;
    margin-left: 5%;
    margin-right: initial;
  }
  div[dir='rtl'] input {
    text-indent: 0;
  }
  div[dir='rtl'] .donate-now .btn-bg1:first-child {
    margin-right: initial;
    margin-left: 50px;
  }
}


@media screen and (min-width: 1200px) and (min-height: 904px) {
  .reports-section {
    width: 80%;
    height: 310px;
  }

  .reports-section div.main-donations {
    max-width: initial;
  }

  .reports-section div.main-donations.other-amount-section img {
    width: 77%;
  }

  .btn-bg1 {
    width: 190px;
    height: 64px;
    min-height: 64px;
  }
  .btn-bg2 {
    width: 182px;
    height: 56px;
  }
  button.login {
    width: 180px;
    height: 54px;
    font-size: 20px;
  }
  .other-amount {
    font-size: 45px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/confirm-screen.vue